<header class="ao-page-head">
  <div>
    <div class="ao-eyebrow">Design system</div>
    <h2>Gallery</h2>
  </div>
  <p class="ao-rule">
    These are the live tokens and shared styles. Screen layouts stay in the approved HTML references.
  </p>
</header>

<div class="ao-note">
  Yellow note banner. Use it for a message that applies to the whole screen.
</div>

<main class="gallery-body">
  <section>
    <h3>Color</h3>
    <div class="swatches">
      <div
        class="swatch"
        *ngFor="let swatch of swatches"
        [style.background]="'var(' + swatch.token + ')'"
        [class.swatch-on-light]="swatch.light"
      >
        <span>{{ swatch.name }}</span>
        <code>{{ swatch.token }}</code>
      </div>
    </div>
  </section>

  <section>
    <h3>Record header</h3>
    <p class="type-sample">Patient and vendor sections. Left aligned, dark type on lighter teal.</p>
    <mat-toolbar class="ao-section-head">
      <span>Patient Information</span>
    </mat-toolbar>
  </section>

  <section>
    <h3>Section bar and job row</h3>
    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header class="ao-section-bar">
          <mat-panel-title>To Do Today</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-table [dataSource]="rows" class="ao-job-table">
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              class="ao-status"
              [class.ao-status-hold]="row.hold"
            >{{ row.status }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="vendor">
            <mat-header-cell *matHeaderCellDef>Vendor</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.vendor }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="model">
            <mat-header-cell *matHeaderCellDef>Model</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.model }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="color">
            <mat-header-cell *matHeaderCellDef>Color</mat-header-cell>
            <mat-cell *matCellDef="let row">{{ row.color }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="patient">
            <mat-header-cell *matHeaderCellDef>Patient</mat-header-cell>
            <mat-cell *matCellDef="let row" class="ao-patient-name">{{ row.patient }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="invoice">
            <mat-header-cell *matHeaderCellDef>Invoice #</mat-header-cell>
            <mat-cell *matCellDef="let row" class="ao-invoice">{{ row.invoice }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="initials">
            <mat-header-cell *matHeaderCellDef>Initials</mat-header-cell>
            <mat-cell *matCellDef="let row" class="ao-initials">{{ row.initials }}</mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: columns; let i = index"
            [class.ao-row-alt]="i % 2 === 1"
          ></mat-row>
        </mat-table>
      </mat-expansion-panel>
    </mat-accordion>
  </section>

  <section>
    <h3>Type</h3>
    <p class="type-sample">Body copy uses Arial. Labels are small, uppercase, and muted.</p>
    <p>Order number <span class="ao-order-number">M94805</span> uses Georgia.</p>
  </section>

  <section>
    <h3>Field and buttons</h3>
    <div class="controls ao-fields">
      <label class="ao-field">
        <span>Model</span>
        <input value="ALBERS" />
      </label>
      <mat-form-field floatLabel="always">
        <mat-label>Material field</mat-label>
        <input matInput value="ALBERS" />
      </mat-form-field>
      <div class="button-row">
        <button type="button" class="ao-button-primary">Save &amp; next</button>
        <button type="button" class="ao-button">Save &amp; hold</button>
        <button type="button" class="ao-icon-button" aria-label="View job">
          <mat-icon>visibility</mat-icon>
        </button>
        <button mat-flat-button color="primary" type="button">Material primary</button>
      </div>
    </div>
  </section>
</main>
